import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import Page from '../components/layout/Page'
import Container from '../components/layout/Container'
import styled from '../utils/styled'
import { ApplicationState } from '../store'
import { clearSelected as clearSelectedEmployee } from '../store/employees/actions'
import { clearSelected as clearSelectedServices } from '../store/services/actions'
import { clearSelected as clearSelectedAvailableTimes } from '../store/availableTimes/actions'
import { Loading } from '../components/data/Loading'
import { useLoadSalonData } from '../hooks/useLoadSalonData'
import { RouteType } from '../types/routes'
import { ErrorPage } from '../components/data/ErrorPage'
import { getUrlWithSalonGuid } from '../utils/urlParams'

const HomePage: React.FC = () => {
  const salonErrors = useSelector((state: ApplicationState) => state.salon.errors)
  const dispatch = useDispatch()
  const { push: navigate } = useHistory()
  const salonData = useSelector((state: ApplicationState) => state.salon.data)

  const clearAllSelectedData = () => {
    dispatch(clearSelectedEmployee())
    dispatch(clearSelectedServices())
    dispatch(clearSelectedAvailableTimes())
  }

  useLoadSalonData({ redirectTo: RouteType.Employees })

  useEffect(() => {
    clearAllSelectedData()
    if (salonData) {
      navigate(getUrlWithSalonGuid(RouteType.Employees))
    }
  }, [])

  return (
    <Page>
      <Container>
        <PageContent>{salonErrors ? <ErrorPage errors={salonErrors} /> : <Loading />}</PageContent>
      </Container>
    </Page>
  )
}

const PageContent = styled('article')`
  max-width: ${props => props.theme.widths.sm};
  margin: 0 auto;
  line-height: 1.6;

  h1,
  h2,
  h3,
  h4 {
    margin-bottom: 0.5rem;
    font-family: ${props => props.theme.fonts.headings};
    line-height: 1.25;
  }
`

export default HomePage
